// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toggle_btnSwitchContainer__WB-dT {
    display: inline-block;
}

.Toggle_btnSwitch__DBCfN {
    display: inline-block;
    width: 40px;
    position: relative;
    user-select: none;
}

.Toggle_btnSwitchCheckbox__qWvCP {
    display: none;
}

.Toggle_btnSwitchLabel__qjh1d {
    margin: 0;
    overflow: hidden;
    border-radius: 20px;
    display: block;
}

.Toggle_btnSwitchInner__NZhpi {
    width: 200%;
    margin-left: -100%;
    transition: margin 0.2s ease-in 0s;
}

.Toggle_btnSwitchInner__NZhpi:before, .Toggle_btnSwitchInner__NZhpi:after {
    padding: 0;
    height: 20px;
    width: 50%;
    float: left;
    line-height: 20px;
    box-sizing: border-box;
}

.Toggle_btnSwitchInner__NZhpi:before {
    padding-left: 10px;
    content: '';
    background: var(--color-green-dark-2);
}

.Toggle_btnSwitchInner__NZhpi:after {
    padding-right: 10px;
    content: '';
    background: var(--color-108);
}

.Toggle_btnSwitchDial__yarp9 {
    margin: -1px;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 3px;
    bottom: 0;
    right: 23px;
    background: var(--color-text-light);
    border-radius: 20px;
    transition: all 0.2s ease-in 0s;
}

.Toggle_btnSwitchCheckbox__qWvCP.Toggle_checked__dlMbl + .Toggle_btnSwitchLabel__qjh1d .Toggle_btnSwitchInner__NZhpi {
    margin-left: 0;
}

.Toggle_btnSwitchCheckbox__qWvCP.Toggle_checked__dlMbl + .Toggle_btnSwitchLabel__qjh1d .Toggle_btnSwitchDial__yarp9 {
    right: 3px;
    background: var(--color-text-light);
}

.Toggle_readOnly__VFaJd {
    opacity: 0.6;
}

.Toggle_readOnlyCursor__NJf4a {
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Toggle/Toggle.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,mCAAmC;IACnC,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".btnSwitchContainer {\n    display: inline-block;\n}\n\n.btnSwitch {\n    display: inline-block;\n    width: 40px;\n    position: relative;\n    user-select: none;\n}\n\n.btnSwitchCheckbox {\n    display: none;\n}\n\n.btnSwitchLabel {\n    margin: 0;\n    overflow: hidden;\n    border-radius: 20px;\n    display: block;\n}\n\n.btnSwitchInner {\n    width: 200%;\n    margin-left: -100%;\n    transition: margin 0.2s ease-in 0s;\n}\n\n.btnSwitchInner:before, .btnSwitchInner:after {\n    padding: 0;\n    height: 20px;\n    width: 50%;\n    float: left;\n    line-height: 20px;\n    box-sizing: border-box;\n}\n\n.btnSwitchInner:before {\n    padding-left: 10px;\n    content: '';\n    background: var(--color-green-dark-2);\n}\n\n.btnSwitchInner:after {\n    padding-right: 10px;\n    content: '';\n    background: var(--color-108);\n}\n\n.btnSwitchDial {\n    margin: -1px;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 3px;\n    bottom: 0;\n    right: 23px;\n    background: var(--color-text-light);\n    border-radius: 20px;\n    transition: all 0.2s ease-in 0s;\n}\n\n.btnSwitchCheckbox.checked + .btnSwitchLabel .btnSwitchInner {\n    margin-left: 0;\n}\n\n.btnSwitchCheckbox.checked + .btnSwitchLabel .btnSwitchDial {\n    right: 3px;\n    background: var(--color-text-light);\n}\n\n.readOnly {\n    opacity: 0.6;\n}\n\n.readOnlyCursor {\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnSwitchContainer": `Toggle_btnSwitchContainer__WB-dT`,
	"btnSwitch": `Toggle_btnSwitch__DBCfN`,
	"btnSwitchCheckbox": `Toggle_btnSwitchCheckbox__qWvCP`,
	"btnSwitchLabel": `Toggle_btnSwitchLabel__qjh1d`,
	"btnSwitchInner": `Toggle_btnSwitchInner__NZhpi`,
	"btnSwitchDial": `Toggle_btnSwitchDial__yarp9`,
	"checked": `Toggle_checked__dlMbl`,
	"readOnly": `Toggle_readOnly__VFaJd`,
	"readOnlyCursor": `Toggle_readOnlyCursor__NJf4a`
};
export default ___CSS_LOADER_EXPORT___;
